import { getEncryptParams } from 'src/keycloak';
import { Builder, appendFormData, getHeaders, getQueryString } from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { DataApiInputParams } from 'src/types/api';
import { getPayload } from 'src/utils/encryption';

type IGetUserGroupsParams = {
  params: {
    show_details?: boolean;
    user_id?: string;
    group_id?: number | string;
    created_by?: string;
    s?: string;
  };
};

export default (builder: Builder) => {
  return {
    getUserGroups: builder.query({
      async queryFn(
        arg: IGetUserGroupsParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const queryString = getQueryString(arg.params);
        let url = `keycloak/Group?${queryString.length ? queryString : ''}`;

        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}?${queryString}${
            queryString.length ? '&' : '?'
          }payload=${btoa(getPayload('', getEncryptParams()))}`;
        }

        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Groups']
    }),
    createUserGroup: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(arg.params);
        let url = `keycloak/Group`;
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Groups']
    }),
    deleteUserGroup: builder.mutation({
      async queryFn(
        args: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/Group`;
        let formData = appendFormData(args.params);
        return fetchWithBQ({
          url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Groups']
    }),
    updateUserGroups: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const formData = appendFormData(arg.params);
        let url = `keycloak/Group`;
        return fetchWithBQ({
          url: url,
          method: 'PUT',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Groups']
    }),
    assignUserRoleToUserGroup: builder.mutation({
      async queryFn(args: DataApiInputParams) {
        // eslint-disable-next-line no-console
        console.log(
          '[userGroups] assignUserRoleToUserGroup stub called with:',
          args.params
        );
        return { data: {} };
      },
      invalidatesTags: ['Groups']
    })
  };
};
